var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcTotalValue = function SvgIcTotalValue(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F0F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3001 22.4773L26.1292 20.2783C25.8352 20.074 25.4893 19.9649 25.1354 19.9648H21.7715C21.4637 19.9648 21.1611 20.0473 20.8931 20.2043C20.625 20.3612 20.4005 20.5873 20.2414 20.8607L19.9215 21.4089C19.7654 21.6768 19.6773 21.9814 19.6653 22.2942C19.6532 22.607 19.7177 22.9179 19.8527 23.1979L20.1422 23.7988C20.3175 24.1628 20.6033 24.4569 20.9556 24.6357C21.3078 24.8145 21.7069 24.8682 22.0914 24.7884L24.9808 24.1884C25.0575 24.1725 25.1365 24.1725 25.2132 24.1885C25.2898 24.2044 25.3627 24.2359 25.4277 24.2811C25.7546 24.507 26.0007 24.8383 26.128 25.2239C26.2553 25.6094 26.2567 26.0278 26.1319 26.4142L26.1167 26.4615L20.8885 28.5482C20.5125 28.6985 20.0987 28.7125 19.7141 28.5881L14.5002 26.89",
    stroke: "#32A4FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4999 19.5734L18.4859 17.0248C18.7981 16.826 19.1614 16.7312 19.5271 16.7531L25.9395 17.1445C26.3401 17.1692 26.7211 17.3325 27.0218 17.6082L30.2294 20.563C30.4633 20.7786 30.6384 21.0543 30.737 21.3624L31.1714 22.7211",
    stroke: "#32A4FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1576 29.2394C24.3736 30.4172 24.9419 31.4945 25.7817 32.3179C26.6215 33.1414 27.6901 33.6692 28.8356 33.8263C29.981 33.9833 31.1451 33.7617 32.1622 33.1928C33.1793 32.624 33.9977 31.7369 34.5011 30.6576C35.0044 29.5784 35.1672 28.362 34.9661 27.1812C34.765 26.0005 34.2104 24.9157 33.381 24.0808C32.5517 23.246 31.4898 22.7037 30.3465 22.5311C29.2031 22.3585 28.0364 22.5643 27.0121 23.1192",
    stroke: "#32A4FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6898 25.8552V24.9277",
    stroke: "#32A4FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3528 31.4229H30.167C30.4459 31.4232 30.7161 31.3227 30.9313 31.1386C31.1465 30.9546 31.2931 30.6984 31.346 30.4143C31.3989 30.1302 31.3548 29.8358 31.2211 29.5819C31.0875 29.3279 30.8728 29.1301 30.6139 29.0227L28.7684 28.2547C28.5091 28.1477 28.2939 27.9501 28.16 27.6961C28.0261 27.442 27.9818 27.1475 28.0347 26.8631C28.0877 26.5788 28.2346 26.3226 28.4501 26.1387C28.6656 25.9547 28.9362 25.8546 29.2152 25.8555H31.0339",
    stroke: "#32A4FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6898 32.3474V31.4209",
    stroke: "#32A4FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTotalValue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-total-value.99d1cd3f.svg";
export { ForwardRef as ReactComponent };